import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { DefaultComponent } from "../../theme/pages/default/default.component";
import { WaypointsMapComponent } from "./Waypoints.component";
import { LayoutModule } from "../../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../freightconfirmation/app.sharemodule";
import { appService } from "../../_services/app.service";
import { CommonService } from "../../_services/common.service";
// import { AgmCoreModule } from "@agm/core";
// import { AgmDirectionModule } from "agm-direction";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

const routes: Routes = [
  {
    path: "",
    component: DefaultComponent,
    children: [
      {
        path: "",
        component: WaypointsMapComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    // RouterModule.forChild(routes),
    LayoutModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    // AgmCoreModule.forRoot({
    //     apiKey: "AIzaSyDBoM5m56db1FvF60EWbmpJDiJVhx1kuUw",
    //     libraries: ["geometry"],
    // }),
    // AgmDirectionModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [WaypointsMapComponent],
  declarations: [WaypointsMapComponent],
  providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class WaypointsMapModule {}
